import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Camera, Clapperboard } from "lucide-react";
import { VisualInspiration } from "./VisualInspiration";
import { ShootingPlan } from "./ShootingPlan";
import { PublishBundle } from "./PublishBundle";

const VIDEO_FORMATS = ["reel", "story", "video_courte"];

export const CreateContent = ({ post, onChange, isDemo }) => {
  const recommended = VIDEO_FORMATS.includes(post.format) ? "video" : "photo";
  const [tab, setTab] = useState(recommended);
  const [status, setStatus] = useState(null);
  const [visuals, setVisuals] = useState([]);
  useEffect(() => { setTab(VIDEO_FORMATS.includes(post.format) ? "video" : "photo"); }, [post.format]);
  useEffect(() => { api.get("/social/visuals/status").then((r) => setStatus(r.data)); api.get(`/social/posts/${post.id}/visuals`).then((r) => setVisuals(r.data)); }, [post.id]);

  const photos = visuals.filter((v) => v.mode !== "storyboard");
  const storyboards = visuals.filter((v) => v.mode === "storyboard");
  const setPhotos = (fn) => setVisuals((v) => [...fn(v.filter((x) => x.mode !== "storyboard")), ...v.filter((x) => x.mode === "storyboard")]);
  const setStoryboards = (fn) => setVisuals((v) => [...v.filter((x) => x.mode !== "storyboard"), ...fn(v.filter((x) => x.mode === "storyboard"))]);

  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/60 p-3 space-y-3" data-testid={`create-content-${post.id}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-[11px] font-bold tracking-wider uppercase text-slate-500">Créer le contenu</p>
        <span className="text-[11px] text-slate-400" data-testid={`create-content-recommended-${post.id}`}>Format recommandé : {recommended === "video" ? "vidéo" : "photo"} ({post.format})</span>
      </div>
      <div className="grid grid-cols-2 gap-1 rounded-xl bg-white p-1 border border-slate-200">
        {[["photo", "Photo", Camera], ["video", "Vidéo", Clapperboard]].map(([k, l, Icon]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`create-content-tab-${k}-${post.id}`} className={`h-10 rounded-lg text-sm font-medium flex items-center justify-center gap-2 ${tab === k ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}>
            <Icon className="w-4 h-4" /> {l}{recommended === k && <span className="text-[9px] uppercase tracking-wide opacity-70">· conseillé</span>}
          </button>
        ))}
      </div>
      {tab === "photo" ? <VisualInspiration post={post} isDemo={isDemo} status={status} setStatus={setStatus} visuals={photos} setVisuals={setPhotos} />
        : <ShootingPlan post={post} onChange={onChange} isDemo={isDemo} status={status} storyboards={storyboards} setStoryboards={setStoryboards} />}
    </div>
  );
};
